import * as ExploreApiService from '../services/api/requests/Explore'

import {
  EXPLORE_ORDER,
  EXPLORE_SHOP,
  EXPLORE_DINE,
  EXPLORE_UNWIND,
  EXPLORE_VIEW_ALL,
} from '../services/data/errorNames.json'

// data
const EXPLORE = 0
const ECONCIERGE = 1
const bannerDescription =
  "Discover what's new and now in shopping, dining, and entertainment when you visit Ayala Malls"
const ENGAGEMENT_TYPES = {
  Shop: 'Visit Virtual Mall',
  Dine: 'Reserve a Restaurant',
  Unwind: 'Book an Appointment',
}

// get data
export const doGetExploreBannerDescription = () => bannerDescription
export const doGetContentTypeExplore = () => EXPLORE
export const doGetContentTypeEConcierge = () => ECONCIERGE
export const doGetEngangementTypes = () => ENGAGEMENT_TYPES

// explore order carousel
export const doGetExploreOrders = ({
  accessToken,
  setMerchantOrder,
  setError,
  removeError,
  errorList,
  onSuccess = () => {},
}) => async (limit, mallSlug) => {
  if (errorList.length) {
    removeError(EXPLORE_SHOP)
  }

  await ExploreApiService.getAllOrderNowMerchants(mallSlug, accessToken, limit)
    .then(response => {
      const { data } = response
      setMerchantOrder(data)
      onSuccess({ data })
    })
    .catch(error => {
      setError({
        name: EXPLORE_ORDER,
        error: error.message,
      })
    })
}

// explore shop carousel
export const doGetExploreShops = ({
  removeError,
  errorList = [],
  preferenceIds = [],
  collectionType = 0,
  onError = () => {},
  setError = () => {},
  onSuccess = () => {},
  setMerchantShop = () => {},
}) => async (limit, mallSlug) => {
  if (errorList.length && collectionType === EXPLORE) {
    removeError(EXPLORE_SHOP)
  }

  await ExploreApiService.getAllShopMerchants({
    limit,
    mallSlug,
    preferenceIds,
    collectionType,
  })
    .then(response => {
      if (collectionType === EXPLORE) setMerchantShop(response.data)
      onSuccess(response)
    })
    .catch(error => {
      if (collectionType === EXPLORE)
        setError({
          name: EXPLORE_SHOP,
          error: error.message,
        })
      onError(error)
    })
}

// explore dine carousel
export const doGetExploreDine = ({
  removeError,
  errorList = [],
  preferenceIds = [],
  collectionType = 0,
  onError = () => {},
  setError = () => {},
  onSuccess = () => {},
  setMerchantDine = () => {},
}) => async (limit, mallSlug) => {
  if (errorList.length && collectionType === EXPLORE) {
    removeError(EXPLORE_DINE)
  }

  await ExploreApiService.getAllDineMerchants({
    limit,
    mallSlug,
    preferenceIds,
    collectionType,
  })
    .then(response => {
      const responseData = Array.from(response.data)
      if (collectionType === EXPLORE) setMerchantDine(responseData.reverse())
      onSuccess(response)
    })
    .catch(error => {
      if (collectionType === EXPLORE)
        setError({
          name: EXPLORE_DINE,
          error: error.message,
        })
      onError(error)
    })
}

// get mall merchants
export const doGetMallMerchants = ({
  mallSlug,
  category,
  onSuccess = () => {},
  onError = () => {},
}) => async mallSlug => {
  await ExploreApiService.getMallMerchants(mallSlug, category)
    .then(response => {
      onSuccess(response)
    })
    .catch(error => {
      onError(error)
    })
}

// explore unwind carousel
export const doGetExploreUnwind = ({
  removeError,
  errorList = [],
  preferenceIds = [],
  collectionType = 0,
  onError = () => {},
  setError = () => {},
  onSuccess = () => {},
  setMerchantUnwind = () => {},
}) => async (limit, mallSlug) => {
  if (errorList.length && collectionType === EXPLORE) {
    removeError(EXPLORE_UNWIND)
  }

  await ExploreApiService.getAllUnwindMerchants({
    limit,
    mallSlug,
    preferenceIds,
    collectionType,
  })
    .then(response => {
      const responseData = Array.from(response.data)
      if (collectionType === EXPLORE) setMerchantUnwind(responseData)
      onSuccess(response)
    })
    .catch(error => {
      if (collectionType === EXPLORE)
        setError({
          name: EXPLORE_UNWIND,
          error: error.message,
        })

      onError(error)
    })
}

// get store for explore page
export const doGetExploreStore = async ({ viewId }) => {
  const response = await ExploreApiService.getStore(viewId)
  const merchantModalData = response.data

  return merchantModalData
}

// get merchant for explore page
export const doGetExploreMerchant = async ({ viewId }) => {
  const merchantResponse = await ExploreApiService.getMerchant(viewId)
  const merchantModalData = { merchant: merchantResponse.data }

  return merchantModalData
}

// get store for dashboard
export const doGetDashboardStore = async ({
  storeId,
  setStoreModalData = () => {},
  onSuccess = () => {},
  onError = () => {},
}) => {
  try {
    ExploreApiService.getStore(storeId)
      .then(response => {
        setStoreModalData(response.data)
        onSuccess(response)
      })
      .catch(error => {
        onError(error)
      })
  } catch (e) {}
}

// get all shops
export const doGetAllExploreShops = async ({
  mallSlug,
  preferenceIds = [],
  collectionType = 0,
  onError = () => {},
  setError = () => {},
  onSuccess = () => {},
}) => {
  try {
    const response = await ExploreApiService.getAllShopMerchants({
      mallSlug,
      preferenceIds,
      collectionType,
    })
    onSuccess(response)
  } catch (error) {
    if (collectionType === EXPLORE)
      setError({
        name: EXPLORE_VIEW_ALL,
        error: error.message,
      })
    onError(error)
  }
}

// get all dine
export const doGetAllExploreDine = async ({
  mallSlug,
  preferenceIds = [],
  collectionType = 0,
  onError = () => {},
  setError = () => {},
  onSuccess = () => {},
}) => {
  try {
    const response = await ExploreApiService.getAllDineMerchants({
      mallSlug,
      preferenceIds,
      collectionType,
    })
    onSuccess(response)
  } catch (error) {
    if (collectionType === EXPLORE)
      setError({
        name: EXPLORE_VIEW_ALL,
        error: error.message,
      })
    onError(error)
  }
}

// get all unwind
export const doGetAllExploreUnwind = async ({
  mallSlug,
  preferenceIds = [],
  collectionType = 0,
  onError = () => {},
  setError = () => {},
  onSuccess = () => {},
}) => {
  try {
    const response = await ExploreApiService.getAllUnwindMerchants({
      mallSlug,
      preferenceIds,
      collectionType,
    })
    onSuccess(response)
  } catch (error) {
    if (collectionType === EXPLORE)
      setError({
        name: EXPLORE_VIEW_ALL,
        error: error.message,
      })
    onError(error)
  }
}

// get all orders
export const doGetAllExploreOrderMerchants = async ({
  mallSlug,
  accessToken,
  onSuccess = () => {},
  onError = () => {},
  setError = () => {},
}) => {
  try {
    const response = await ExploreApiService.getAllOrderNowMerchants(
      mallSlug,
      accessToken,
    )
    onSuccess(response)
  } catch (error) {
    setError({
      name: EXPLORE_VIEW_ALL,
      error: error.message,
    })
    onError()
  }
}

// get store from rewards catalog
export const doGetRewardsStore = ({
  partner,
  setMerchantModalData = () => {},
  onSuccess = () => {},
  onError = () => {},
}) => async viewId => {
  let thePartner = partner
  try {
    if (!partner) {
      const response = await ExploreApiService.getStore(viewId)
      thePartner = response.data
      onSuccess(response)
    }
    setMerchantModalData(thePartner)
    return thePartner
  } catch (error) {
    onError(error)
  }
}

// get Zing partners
export const doGetZingPartners = async ({
  accessToken,
  selectedMall = {},
  onSuccess = () => {},
  onError = () => {},
}) => {
  await ExploreApiService.getZingPartners(accessToken, selectedMall)
    .then(response => {
      onSuccess(response)
    })
    .catch(error => {
      onError(error)
    })
}
